import { RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { UploadType, UPLOAD_TYPE_CONFIGS } from '@/types/upload.types';
import { UploadTypeSelectorProps } from './UploadTypeSelector.types';

export const UploadTypeSelector = ({ selectedType, canUploadOkko, canUploadCompetitors, canUploadCompetitorsData, className, disabled, onChange }: UploadTypeSelectorProps) => {
  return (
    <div className="upload-radio-container">
      <RadioGroup className={className || 'upload-radio-group'} value={selectedType || ''} onChange={onChange}>
        {UPLOAD_TYPE_CONFIGS.filter(fileType => {
          if (fileType.type === UploadType.OKKO_PRICES || fileType.type === UploadType.DISCOUNTS) {
            return canUploadOkko;
          }
          if (fileType.type === UploadType.COMPETITORS_DATA) {
            return canUploadCompetitorsData;
          }
          return canUploadCompetitors;
        }).map(fileType => (
          <FormControlLabel key={fileType.type} value={fileType.type} control={<Radio disabled={disabled} />} label={fileType.label} />
        ))}
      </RadioGroup>
    </div>
  );
};
